// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"236":"f239c5c7","907":"9f76a7c4"}[chunkId] + ".css";
};